import Pattern from '../ASSETS/NumericaPattern.png';

export const Background = `radial-gradient(transparent, black 100%), url(${Pattern})`;
